var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.502 13.486-5-5.293a.598.598 0 0 0-.88 0l-.44.466a.686.686 0 0 0 0 .931l5.72 6.055c.019.02.04.04.06.057l.103.108a.605.605 0 0 0 .89-.01L17.81 9.6a.695.695 0 0 0 .01-.942l-.44-.466a.605.605 0 0 0-.89.011l-4.988 5.281Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;